<template>
  <div
    v-if="$auth.user"
    class="container-fluid w-100 h-100">
    <div class="row">
      <div class="col-md-2">
        <div class="nav flex-column nav-pills mb-2">
          <template v-if="userRole === 'admin'">
            <li class="nav-item">
              <router-link
                to="/users"
                class="nav-link">Admin</router-link>
            </li>
          </template>
          <router-link
            :to="{ name: 'profile' }"
            active-class="active"
            class="nav-link">Main info</router-link>
          <router-link
            :to="{ name: 'profile-change-password' }"
            active-class="active"
            class="nav-link"
          >Change password</router-link>

          <router-link
            :to="{ name: 'profile-lic-request' }"
            active-class="active"
            class="nav-link"
          >Request license</router-link>
          <router-link
            :to="{ name: 'profile-download-software' }"
            active-class="active"
            class="nav-link"
          >Download software</router-link>
        </div>
      </div>
      <div class="col-md-10">
        <div class="tab-content">
          <div class="tab-pane fade show active">
            <div class>
              <transition
                name="router"
                mode="out-in">
                <router-view />
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Profile',
  data: () => ({
    userRole: store.state.auth.user.role
  }),
  computed: {
    ...mapState('auth', [
      'user'
    ]),
    ...mapGetters('auth', ['loggedIn'])
  }
}
</script>

<style>
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #4f778b !important;
}
</style>
